import '../Body.css';
import wildRose from '../../assets/images/wildRose.png'
import React from "react";

function Home(props) {

    return (
        <div className="home">
            <img className="wildRoseImage" src={wildRose} alt="text reading wild roses endometriosis research foundation, next to a face blurred feminine silhouette coming out of a red rose " />
        </div>
    )
}

export default Home;